var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#212B36;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,23.8l-1.1-13.5c-0.1-0.9-0.8-1.6-1.7-1.6h-2.1v3.1c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7V8.7h-6.5 v3.1c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7V8.7H8.8c-0.9,0-1.6,0.7-1.7,1.5L6,23.8c-0.1,1.1,0.3,2.2,1,3 C7.8,27.5,8.8,28,9.9,28h11.2c1.1,0,2.1-0.5,2.9-1.3C24.7,26,25.1,24.9,25,23.8z M18.7,16.9L15,20.5c-0.1,0.1-0.3,0.2-0.5,0.2 c-0.2,0-0.4-0.1-0.5-0.2l-1.7-1.7c-0.3-0.3-0.3-0.7,0-1c0.3-0.3,0.7-0.3,1,0l1.2,1.2l3.1-3.1c0.3-0.3,0.7-0.3,1,0 C19,16.2,19,16.6,18.7,16.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.5,4c-2.6,0-4.6,2.1-4.6,4.6v0.1h1.4V8.6c0-1.8,1.5-3.2,3.2-3.2s3.2,1.5,3.2,3.2v0.1h1.4V8.6 C20.2,6.1,18.1,4,15.5,4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceOrder);
export default __webpack_public_path__ + "static/media/place_order.3b0e34dafc93d49da25bb7fd115ce306.svg";
export { ForwardRef as ReactComponent };